import { Box, Typography } from '@mui/material';
import { CopyEntryDetailsDto } from '@act/shared/data-transfer-objects';
import { reemaColors } from '@act/storybook';

export interface CopyEntryProps {
  entry: CopyEntryDetailsDto;
}

const CopyEntry = ({ entry }: CopyEntryProps) => {
  return (
    <Box component="div" className="copy-entry" sx={{ marginLeft: '16px' }}>
      {entry.title && (
        <Typography
          component="span"
          className="entry-title"
          variant="subheadMedium"
          color={reemaColors.black}
        >
          {entry.title}
        </Typography>
      )}
      <Box component="div">
        {entry.copyType === 'paragraph' && (
          <Box component="div">
            {entry.copyBlocks.map((block, index) => {
              return <p key={`${block}-${index}`}>{block.copy}</p>;
            })}
          </Box>
        )}
        {entry.copyType === 'ordered-list' && (
          <Box component="div">
            <ol>
              {entry.copyBlocks.map((block, index) => {
                return (
                  <li
                    key={`${block}-ordered-${index}`}
                    style={{ marginBottom: '8px' }}
                  >
                    {block.title && (
                      <Typography
                        component="div"
                        variant="subheadMedium"
                        color={reemaColors.black}
                      >
                        {block.title}
                      </Typography>
                    )}
                    {block.copy}
                  </li>
                );
              })}
            </ol>
          </Box>
        )}
        {entry.copyType === 'unordered-list' && (
          <Box component="div">
            <ul>
              {entry.copyBlocks.map((block, index) => {
                return (
                  <li key={`${block}-unordered-${index}`}>{block.copy}</li>
                );
              })}
            </ul>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default CopyEntry;
